module.exports = __webpack_public_path__ + "static/media/missing-payment-data.f210d008.png";